import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { DeviceIntervalsState } from './types'
import { DEVICE_INTERVALS_ACTIONS, DEVICE_INTERVALS_GETTERS } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const deviceIntervals: Module<DeviceIntervalsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export { DEVICE_INTERVALS_ACTIONS, DEVICE_INTERVALS_GETTERS }
export type { DeviceIntervalsState }
export default deviceIntervals
